var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChecklist = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6780AA",
  fillRule: "evenodd",
  d: "M9.73 7.77h17.52v2.46H9.73zm0 9.96v-2.46h17.52v2.46zm0 7.5v-2.46h17.52v2.46zm-3.75-3.12q.78 0 1.335.57T7.87 24t-.57 1.305-1.32.555-1.305-.555T4.12 24t.54-1.32 1.32-.57m0-15q.78 0 1.335.555T7.87 9c0 .78-.185.96-.555 1.32q-.555.54-1.335.54c-.78 0-.96-.18-1.32-.54Q4.12 9.78 4.12 9c0-.78.18-.965.54-1.335q.54-.555 1.32-.555m0 7.5q.78 0 1.335.555T7.87 16.5c0 .78-.185.96-.555 1.32q-.555.54-1.335.54c-.78 0-.96-.18-1.32-.54q-.54-.54-.54-1.32c0-.78.18-.965.54-1.335q.54-.555 1.32-.555"
})));
export default SvgChecklist;